var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.04,
    height: 16.007,
    viewBox: "0 0 16.04 16.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M1.569,14.879A3.133,3.133,0,0,1,0,12.309,3.159,3.159,0,0,1,1.577,9.724a7.946,7.946,0,0,1,8.124,0,3.15,3.15,0,0,1,1.568,2.569A3.158,3.158,0,0,1,9.7,14.879a7.4,7.4,0,0,1-4.066,1.128A7.4,7.4,0,0,1,1.569,14.879Zm10.26-.673a2.857,2.857,0,0,0,.977-1.857,3.154,3.154,0,0,0-1.337-2.7,6.594,6.594,0,0,0-1.84-1.008,6.256,6.256,0,0,1,5.362.936,2.432,2.432,0,0,1,1.041,2.1,2.439,2.439,0,0,1-1.393,1.905,5.585,5.585,0,0,1-2.651.626ZM5.755,7.595h-.04a.65.65,0,0,0-.176,0,3.782,3.782,0,1,1,.232,0Zm3.97-.872a3.664,3.664,0,0,0,1.2-3.041,3.713,3.713,0,0,0-.617-1.745,2.873,2.873,0,1,1,1.617,5.434h-.04a.363.363,0,0,0-.136.017q-.081,0-.161,0A2.853,2.853,0,0,1,9.724,6.723Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuGroup);
export default __webpack_public_path__ + "static/media/icon-menu-group.43e33134d01a9cfa958dca4744785802.svg";
export { ForwardRef as ReactComponent };